import {Component, OnInit, input} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import * as fromSetting from '../store/setting.reducers';
import * as SettingAction from '../store/setting.actions';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-subscription-item-list',
    templateUrl: './subscription-item-list.component.html',
    styleUrls: ['./subscription-item-list.component.scss'],
    standalone: false
})
export class SubscriptionItemListComponent implements OnInit {

  readonly subscriptionId = input<number>(undefined);
  settingState: Observable<fromSetting.State>;

  constructor(
    public store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.settingState = this.store.select('setting');
    this.store.dispatch(
      new SettingAction.GetSubscriptionItems({
        id: this.subscriptionId()
      })
    );
  }

}
